var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ctIi18n"},[(_vm.title.indexOf('%s') >= 0)?_vm._l((_vm.listI18n),function(item,idx){return _c('span',{key:idx},[_vm._v(" "+_vm._s(item.name)+" "),_vm._t(`i18n-${item.index}`)],2)}):[_vm._v(" "+_vm._s(_vm.title)+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }